/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function () {
  if (document.body.dataset.editorMode === 'true') {
    return;
  }

  var editableSelector = 'input, textarea, select, [contenteditable="true"], [data-allow-copy]';

  function isEditable(target) {
    return target instanceof Element && Boolean(target.closest(editableSelector));
  }

  document.addEventListener('contextmenu', function (event) {
    if (!isEditable(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener('copy', function (event) {
    if (!isEditable(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener('cut', function (event) {
    if (!isEditable(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (event) {
    if (event.target instanceof Element && event.target.closest('img, picture')) {
      event.preventDefault();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!event.ctrlKey && !event.metaKey) {
      return;
    }

    var key = event.key.toLowerCase();
    var editableShortcut = isEditable(event.target) && ['a', 'c', 'x'].includes(key);

    if (!editableShortcut && ['a', 'c', 'p', 's', 'u', 'x'].includes(key)) {
      event.preventDefault();
    }
  });
})();

document.addEventListener('change', function (event) {
  if (!event.target || typeof event.target.closest !== 'function') {
    return;
  }

  var input = event.target.closest('.js-top-filters-form input[type="checkbox"]');

  if (!input) {
    return;
  }

  var topForm = input.closest('.js-top-filters-form');
  var productSearch = input.closest('dynamic-product-search');

  if (!topForm) {
    return;
  }

  var topFilterNames = Array.from(topForm.elements).reduce(function (names, element) {
    if (element.name) {
      names.add(element.name);
    }

    return names;
  }, new Set());

  var params = new URLSearchParams();
  var forms = [
    topForm,
    productSearch && productSearch.querySelector('.js-sort-form'),
    productSearch && productSearch.querySelector('.js-filters-form')
  ].filter(Boolean);

  forms.forEach(function (form) {
    var formData = new FormData(form);

    formData.forEach(function (value, name) {
      if (form !== topForm && topFilterNames.has(name)) {
        return;
      }

      params.append(name, value);
    });
  });

  var query = params.toString();

  if (productSearch && typeof productSearch.renderCollection === 'function') {
    productSearch.renderCollection({ query: query });
    return;
  }

  window.location.href = window.location.pathname + (query ? '?' + query : '');
});
